import React from 'react';
import { Popover, Typography } from '@mui/material';
import { PlaylistAnimationEnum } from '@modules/digital-signage/model/playlists.model.ts';
import { AnimationPreviewPopoverProps, ANIMATION_LABELS } from '@modules/digital-signage/model/animation-preview-popover.model.ts';
import AppImage from '@components/app-image/app-image.tsx';
import previewImage1 from '@assets/images/digital-signage/animate-1.jpg';
import previewImage2 from '@assets/images/digital-signage/animate-2.jpg';
import './animation-preview-popover.scss';

const AnimationPreviewPopover: React.FC<AnimationPreviewPopoverProps> = ({
  anchorEl,
  animation,
  previewSrc,
  onClose
}) => {
  const open = Boolean(anchorEl);

  return (
    <Popover
      open={open}
      anchorEl={anchorEl}
      onClose={onClose}
      anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      transformOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      slotProps={{
        paper: {
          elevation: 4,
          sx: {
            borderRadius: 2,
            p: 1,
            display: 'flex',
            flexDirection: 'column',
            gap: 1
          }
        }
      }}
    >
      <Typography variant="caption" textAlign="center" className="opacity-60!">
        {ANIMATION_LABELS[animation]}
      </Typography>

      <div
        className={`animation-preview animation-preview-${animation}`}
        style={{ width: 220, height: 128 }}
      >
        <div className="animation-preview-slide animation-preview-slide-b">
          <AppImage
            previewSrc={previewImage2}
            width="100%"
            height="100%"
            disableModalClick
            hideSkeleton
            objectFit="cover"
          />
        </div>
        <div className="animation-preview-slide animation-preview-slide-a">
          <AppImage
            previewSrc={previewSrc || previewImage1}
            width="100%"
            height="100%"
            disableModalClick
            hideSkeleton
            objectFit="cover"
          />
        </div>
      </div>
    </Popover>
  );
};

export default AnimationPreviewPopover;
